export const data = {
    labels: [''],
    datasets: [
        {
            label: 'ist',
            data: [0],
            backgroundColor: "rgba(34, 197, 94, 0.85)",     // erreicht → grün ✓
        },
        {
            label: 'soll',
            data: [0],
            backgroundColor: "rgba(251, 191, 36, 0.7)",    // noch offen → amber ⚠️
        },
        {
            label: 'überschuss',
            data: [0],
            backgroundColor: "rgba(15, 118, 110, 0.85)",   // Bonus → Teal 💎
        }
    ]
};